import { render, staticRenderFns } from "./SubmitFormItemIndicator.vue?vue&type=template&id=54945a58&scoped=true"
import script from "./SubmitFormItemIndicator.vue?vue&type=script&lang=js"
export * from "./SubmitFormItemIndicator.vue?vue&type=script&lang=js"
import style0 from "./SubmitFormItemIndicator.vue?vue&type=style&index=0&id=54945a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54945a58",
  null
  
)

export default component.exports